function SectionTitle({ label, variant = "light", as: Tag = "h2", className = "" }) {
  return (
    <Tag
      className={`section-heading section-heading--${variant} ${className}`.trim()}
    >
      <span className="section-heading-rule" aria-hidden="true" />
      <span className="section-heading-text">{label}</span>
      <span className="section-heading-rule" aria-hidden="true" />
    </Tag>
  );
}

export default SectionTitle;
